// An emission-factor value exactly as stored: no rounding, no fixed decimals. JavaScript prints a very small number
// in scientific notation (2.05e-9), so it cannot be mistaken for 0.
export function formatFactorValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  const num = Number(value);
  return Number.isNaN(num) ? '—' : String(num);
}

// Derive a friendly display name from an email address.
// e.g. "arpit.samdani@greenstitch.io" -> "Arpit Samdani", "arpit@x.io" -> "Arpit".
// Returns '' for empty/invalid input so callers can fall back.
export function nameFromEmail(email) {
  const local = (email || '').split('@')[0];
  if (!local) return '';
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

// Minor words that stay lowercase in headline-style Title Case (unless first/last).
const TITLE_CASE_MINOR_WORDS = new Set([
  'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'if', 'in', 'nor', 'of',
  'on', 'or', 'per', 'the', 'to', 'via', 'vs', 'with',
]);

/**
 * Convert a string to Title Case (headline style): major words capitalised,
 * minor words lowercased except when first or last. Acronyms and intentionally
 * mixed-case tokens (PET, HDPE, kWh, CO2) are preserved as-is.
 */
export function toTitleCase(str) {
  if (!str || typeof str !== 'string') return str;
  const tokens = str.split(/(\s+)/); // keep whitespace separators
  const wordIndexes = tokens
    .map((t, i) => (/\S/.test(t) ? i : -1))
    .filter((i) => i !== -1);
  const firstWord = wordIndexes[0];
  const lastWord = wordIndexes[wordIndexes.length - 1];

  return tokens
    .map((token, i) => {
      if (!/\S/.test(token)) return token; // whitespace
      // Preserve acronyms / intentional casing (all-caps or internal capitals)
      if (/[A-Z]/.test(token.slice(1)) || (token === token.toUpperCase() && /[A-Z]/.test(token))) {
        return token;
      }
      const lower = token.toLowerCase();
      const isMinor = TITLE_CASE_MINOR_WORDS.has(lower.replace(/[^a-z]/g, ''));
      if (isMinor && i !== firstWord && i !== lastWord) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
}
